import { WindowBreakpoints } from '@dustin-web/microsite-config'
import classNames from 'classnames'
import Link from 'next/link'
import { useTranslations } from 'packages/microsite-components/src/hooks'
import { Icon } from 'packages/microsite-components/src/icon-library'
import { useTrackingOnScreen } from 'packages/microsite-components/src/on-screen'
import { DigitalData } from 'packages/microsite-components/src/utils/digital-data'

type Props = {
  breakpoints: WindowBreakpoints
}

export default function TakebackCheckoutCard({ breakpoints }: Props) {
  const { translate } = useTranslations()
  const ref = useTrackingOnScreen(() => {
    DigitalData.pushViewPromotion({
      creative_name: 'takeback',
      promotion_name: 'order-confirmation_banner',
      creative_slot: 'service_icons',
      promotion_id: '',
    })
  })

  const onClick = (selectedService: string) => {
    DigitalData.pushSelectPromotion({
      promotion_id: '',
      creative_name: selectedService,
      promotion_name: 'order-confirmation_banner',
      creative_slot: 'service_icons',
    })
  }

  return (
    <article className="col-lg-4 col-sm-12">
      <Link
        className="c-product-card c-product-card--list u-bg-dark-green u-color-light-green a-no-styling u-px-16 u-py-16"
        href={translate('Link_Takeback')}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onClick('takeback')}>
        <div
          className={classNames('d-flex', {
            'flex-column': breakpoints.min.LG,
          })}>
          <header ref={ref}>
            <div>
              <h2
                className={classNames('h5 u-color-green', {
                  'u-fs-12': breakpoints.max.SM,
                })}>
                Takeback
              </h2>
              <h3 className={breakpoints.max.SM ? 'u-fs-14 u-mb-0' : ''}>
                {translate('Takeback_Card_Subheader')}
              </h3>
            </div>
          </header>
          {breakpoints.min.LG && (
            <p className="u-fs-14">{translate('Takeback_Card_Information')}</p>
          )}
        </div>
        <Icon className="i-24 align-self-center align-self-lg-end" name="arrow-right" />
      </Link>
    </article>
  )
}
